import {
  Box,
  Text,
  getThemeColor,
  getThemeSpacing,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Card = styled(Box)`
  width: 100%;
  padding: ${({ theme }) => getThemeSpacing(3, theme)};
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  border-radius: ${({ theme }) => theme.border_radius.card};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  gap: ${({ theme }) => getThemeSpacing(2, theme)};
  background-color: ${({ theme }) => getThemeColor('white', theme)};
  flex-direction: column;
  height: 100%;
`

export const IconContainer = styled(Box)`
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.box_shadow.card};
`

export const BigNumber = styled(Text)`
  & p {
    font-size: 36px;
    font-weight: 500;
  }
`
export const CircleBackground = styled(Box)`
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${({ theme }) => getThemeColor('warning', theme)}22;
  font-size: 14px;
  color: ${({ theme }) => getThemeColor('warning', theme)};
`

export const Badge = styled.small<{ active: boolean }>`
  ${({ active, theme }) => {
    if (active) {
      return `
        color: ${getThemeColor('purple', theme)};
        border: 1px solid ${getThemeColor('purple', theme)};
        background-color: ${getThemeColor('purple', theme) + 22};
      `
    }

    return `
      color: ${getThemeColor('grey_4', theme)};
      border: 1px solid ${getThemeColor('grey_4', theme)};
      background-color: ${getThemeColor('grey_5', theme)};
    `
  }}

  font-weight: 500;
  padding: 4px 12px;
  border-radius: 50px;
`
